import OLLayerProperty from 'ol/layer/Property';

export const LayerProperty = Object.assign({
  TYPE: 'type',
  ID: 'id',
  NAME: 'name',
  VISIBLE_IN_LAYERLIST: 'visibleInLayerList',
  LEGEND_URL: 'legendUrl',
  HAS_FEATURES: 'hasFeatures',
  HAS_FEATURE_INFO: 'hasFeatureInfo',
  HAS_TIMELINES: 'hasTimelines',
  HAS_ATTACHMENTS: 'hasAttachments',
  EXPORTABLE_AS_SHAPE_FILE: 'exportableAsShapeFile',
  EXPORTABLE_AS_KML: 'exportableAsKml',
  EXPORTABLE_AS_EXCEL: 'exportableAsExcel',
  FEATURE_INFO_VERSION: 'featureInfoVersion',
  GEOMETRY_TYPE: 'geometryType',
  SHORTCUT_ACTIONS: 'actions',
  IS_INTERSECTABLE: 'intersectable',
  CONFIGURATION_CONSTRAINTS: 'configurationConstraints',
  IS_FILTERABLE: 'filterable',
  IS_FILTERED: 'filtered',
  SUGGESTED_EXTENT: 'suggestedExtent',
  HAS_PROCESSINGS: 'hasProcessings',
  SELECTED_FEATURE_IDS: 'selectedFeatureIds', // Currently in use by the vector layer (feature layer rendered on the client side).
  SNAPPABLE: 'snappable',
  LIFECYCLE_ACTIONS: 'lifecycleActions',
  IS_VERSION_THEME: 'versionTheme',
  IS_REPOSITORY_ITEM_THEME: 'repositoryItemTheme',
  IS_TRANSIENT_REPOSITORY_ITEM_THEME: 'transientRepositoryItemTheme',
  ALL_ACTIONS_MAPPING: 'allActionsMapping',
  TASK_ID_IN_PROGRESS_BY_ACTION_TYPE: 'taskIdInProgressByActionType',
  PRIVILEGES: 'privileges',
  HELP_URL: 'helpUrl',
  RELOAD_INTERVAL: 'reloadInterval',
  IS_GROUP_THEME: 'groupTheme',
  TOGGLE_CHOICES: 'toggleGroupChoices',
  NORMAL_GROUP_CHOICES: 'normalGroupChoices',
  TOGGLE_GROUP_ACTIVE_LAYER_INDEX: 'toggleGroupActiveLayerIndex', // For toggle groups: the index of the currently selected sub-layer
  VISIBLE_SUB_LAYER_INDEXES: 'visibleSubLayerIndexes', // For layer groups: this is used in the front-end only to manage state of visible layers for transient maps
  IS_SELECTOR_LAYER: 'selectorLayer',
  SELECTOR_EXECUTION_TYPE: 'selectorExecutionType',
  CONDITION_DEFINITION_SET_ID: 'conditionDefinitionSetId',
  CONDITION_VALUES_SET_HASH: 'conditionValuesSetHash',
  INITIAL_CONDITION_VALUES_SET_HASH: 'initialConditionValuesSetHash',
  ATTRIBUTES: 'attributes',
  AVAILABLE_STYLES: 'availableStyles',
  ZOOM_ON_FILTERING_MODE: 'zoomOnFilterChangeMode',
  IN_RANGE: 'inRange',
  HAS_APPLICABLE_TEMPLATES: 'hasApplicableTemplates',
  IMG_LOAD_EXECUTION_HELPER: 'imgLoadExecutionHelper',
  TASKS: 'tasks',
  EXTENDED_INFO: 'extendedInfo',
  STRUCTURED_LEGEND_LAYER: 'structuredLegendLayer',
  SUPPORTS_ATTRIBUTES_EDIT: 'supportsAttributesEdit',
  SUPPORTS_GEOMETRY_EDIT: 'supportsGeometryEdit',
  SUPPORTS_FEATURE_CREATION: 'supportsFeatureCreation',
  SUPPORTS_FEATURE_REMOVAL: 'supportsFeatureRemoval',
  IS_LIVE_LAYER: 'liveLayer',
  HAS_EMPTY_REQUIRED_CONDITIONS: 'hasEmptyRequiredConditions',
  TOGGLE_GROUP_LAYERS: 'toggleGroupLayers'
}, OLLayerProperty);
